import React from "react";
import PropTypes from "prop-types";
import { Flex, Text } from "@badi/badi-components";
import { Root } from "./styled-components";

const Metric = ({ children, label, dataQa = "metric-seeker" }) => (
  <Root>
    <Flex direction="column">
      <Text body="14-Bold" dataQa={`${dataQa}-label`}>
        {label}
      </Text>
      <Text body="14-Regular" dataQa={`${dataQa}-value`}>
        {children}
      </Text>
    </Flex>
  </Root>
);

Metric.propTypes = {
  children: PropTypes.string.isRequired,
  dataQa: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default Metric;
